module.exports = __webpack_public_path__ + "media/images/brand/background-41e746015b05be4f80e7d131c6774fcd.svg";